import { ReactNode } from "react";
import "../stylesheets/linkCard.scss";

// TYPES

type LinkCardProps = {
	title: string;
	img: string;
	children?: ReactNode[];
};

// COMPONENT

function LinkCard({ title, img, children }: LinkCardProps) {
	return (
		<div className="link-card">
			<h3>{title}</h3>
			<img src={img} alt={title} />
			<div>{children}</div>
		</div>
	);
}

export default LinkCard;
